export default __webpack_public_path__ + "static/thr-hero-3cf04e60c8e5486ccc06507b7ca0a00f.jpg";